import React from 'react';

import type { CoveragesTableProps } from '../../../types/vida/table/coveragesTableType';
import Tooltip from '../../tooltip/Tooltip';

const CoveragesTable: React.FC<CoveragesTableProps> = ({
  coverages,
  onRowClick,
  emptyMessage = 'Nenhuma cobertura encontrada',
}) => {
  return (
    <div className="w-full min-h-[150px] overflow-x-auto custom-scrollbar rounded-md shadow-xs">
      <div>
        <table className="min-w-[1200px] w-full table-fixed">
          <thead>
            <tr>
              <th className="px-4 py-2 text-left text-sm font-semibold border-b border-gray-100 w-[200px]" scope="col">
                <Tooltip label="Nome da cobertura">
                  <span>Cobertura</span>
                </Tooltip>
              </th>
              <th className="px-4 py-2 text-left text-sm font-semibold border-b border-gray-100 whitespace-nowrap" scope="col">
                <Tooltip label="Percentual da cobertura em relação à básica">
                  <span>% da Básica</span>
                </Tooltip>
              </th>
              <th className="px-4 py-2 text-left text-sm font-semibold border-b border-gray-100 whitespace-nowrap" scope="col">
                <Tooltip label="Limite de capital para a cobertura">
                  <span>Limite Capital</span>
                </Tooltip>
              </th>
              <th className="px-4 py-2 text-left text-sm font-semibold border-b border-gray-100 whitespace-nowrap" scope="col">
                <Tooltip label="Valor de capital fixo">
                  <span>Capital Fixo</span>
                </Tooltip>
              </th>
              <th className="px-4 py-2 text-left text-sm font-semibold border-b border-gray-100 whitespace-nowrap" scope="col">
                <Tooltip label="Quantidade de vidas ou itens">
                  <span>Qtde</span>
                </Tooltip>
              </th>
              <th className="px-4 py-2 text-left text-sm font-semibold border-b border-gray-100 whitespace-nowrap" scope="col">
                <Tooltip label="Prêmio associado à cobertura">
                  <span>Prêmio</span>
                </Tooltip>
              </th>
              <th className="px-4 py-2 text-left text-sm font-semibold border-b border-gray-100 whitespace-nowrap" scope="col">
                <Tooltip label="Período de carência">
                  <span>Carência</span>
                </Tooltip>
              </th>
              <th className="px-4 py-2 text-left text-sm font-semibold border-b border-gray-100 whitespace-nowrap" scope="col">
                <Tooltip label="Tipo de carência aplicada">
                  <span>Tipo Carência</span>
                </Tooltip>
              </th>
              <th className="px-4 py-2 text-left text-sm font-semibold border-b border-gray-100 whitespace-nowrap" scope="col">
                <Tooltip label="Franquia da cobertura">
                  <span>Franquia</span>
                </Tooltip>
              </th>
              <th className="px-4 py-2 text-left text-sm font-semibold border-b border-gray-100 whitespace-nowrap" scope="col">
                <Tooltip label="Tipo de franquia aplicada">
                  <span>Tipo Franquia</span>
                </Tooltip>
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-50 text-text-color">
            {coverages && coverages.length > 0 ? (
              coverages.map((coverage) => (
                <tr
                  key={coverage.id}
                  className={`hover:bg-gray-50 transition-colors text-xs ${onRowClick ? 'cursor-pointer' : ''}`}
                  onClick={() => onRowClick?.(coverage)}
                >
                  <td className="px-4 py-2 align-top break-words">{coverage.coverage}</td>
                  <td className="px-4 py-2 whitespace-nowrap align-top">{coverage.basicPercentage}</td>
                  <td className="px-4 py-2 whitespace-nowrap align-top">{coverage.capitalLimit}</td>
                  <td className="px-4 py-2 whitespace-nowrap align-top">{coverage.fixedCapital}</td>
                  <td className="px-4 py-2 whitespace-nowrap align-top">{coverage.quantity}</td>
                  <td className="px-4 py-2 whitespace-nowrap align-top">{coverage.premium}</td>
                  <td className="px-4 py-2 whitespace-nowrap align-top">{coverage.gracePeriod}</td>
                  <td className="px-4 py-2 whitespace-nowrap align-top">{coverage.gracePeriodType}</td>
                  <td className="px-4 py-2 whitespace-nowrap align-top">{coverage.franchise}</td>
                  <td className="px-4 py-2 whitespace-nowrap align-top">{coverage.franchiseType}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={10} className="px-4 py-4 text-center text-text-color text-xs">
                  {emptyMessage}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CoveragesTable;

